<template>
  <ABCheckbox :model-value="value" :read-only="true" />
</template>

<script>
import ABCheckbox from '@grouper/modules/builder/components/elements/baseComponents/ABCheckbox'
import collectionField from '@grouper/modules/builder/mixins/collectionField'

export default {
  name: 'BooleanField',
  components: { ABCheckbox },
  mixins: [collectionField],
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
